/**
 * aClaw Web 应用入口
 *
 * 根据 URL 路径决定挂载哪个顶层组件：
 *   /console/*  → <console-app>（aClaw 控制台）
 *   其他路径    → <openclaw-app>（Dashboard / chat 界面）
 *
 * 根路径 "/" 强制跳转到 /console。
 */

const path = window.location.pathname;

// Service shutdown: /console and /login redirect to the announcement page.
const SHUTDOWN_REDIRECT_URL = "https://aclaw.ai/openclaw-cloud";
if (
  path === "/console" || path.startsWith("/console/") ||
  path === "/login" || path.startsWith("/login/")
) {
  window.location.replace(SHUTDOWN_REDIRECT_URL);
  // Stop further module evaluation while the browser navigates away.
  throw new Error("Service shutdown: redirecting to " + SHUTDOWN_REDIRECT_URL);
}

// Root always goes to console
if (path === "/" || path === "") {
  window.location.replace("/console");
}

const isConsole = path === "/console" ||
  path.startsWith("/console/");

if (isConsole) {
  await import("./console/console.css");
  await import("./console/console-app.ts");
  document.body.appendChild(document.createElement("console-app"));
} else {
  await import("./app/styles.css");
  await import("./app/ui/app.ts");
  document.body.appendChild(document.createElement("openclaw-app"));
}
